const img = {
	construccion: require('./const.png'),
	pdf: require('./file.jpeg'),
	login: require('./imagendefondo.jpg'),
};

export default img;
